import { Text } from "@certn/cascadia";
import { Card, Container, Illustration } from "@certn/cascadia-react";
import { css } from "@emotion/css";

interface Props {
  title: string;
  message: string;
}

export function NotFoundError({ title, message }: Props) {
  return (
    <Container layout="auth" testID="not-found-error">
      <Card type="large" border="dropshadow" className={styles.card}>
        <Illustration name="no-results" />
        <div className={styles.content}>
          <Text
            style="form/page-title"
            align="center"
            testID="not-found-error-title"
          >
            {title}
          </Text>
          <Text
            style="global/body-primary"
            align="center"
            color="text-weak"
            testID="not-found-error-message"
          >
            {message}
          </Text>
        </div>
      </Card>
    </Container>
  );
}

const styles = {
  card: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "var(--space-6)",
    gap: "var(--space-6)",
  }),
  content: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-2)",
  }),
};
